export default "__VITE_ASSET__gGm3Kvl___"